import { Row, Typography, CircularLoader, CloseButton, Box, useOverlayContext, ConfirmationModal, Column } from 'seagull';
import { Download } from 'seagull/icons';
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { formatFileSize } from "../../utils/fileSize.utils";
import { AttachmentsTestIds } from "./Attachments.utils";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const AttachmentFile = _ref => {
  let {
    file,
    index,
    onRemove
  } = _ref;
  const isVendor = useStore(selectors.user.isVendor);
  const overlayContext = useOverlayContext();
  const handleRemove = () => {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          skin: "danger",
          title: "Remove file",
          content: /*#__PURE__*/_jsxs(Column, {
            gap: 8,
            children: [/*#__PURE__*/_jsxs(Typography, {
              align: "left",
              children: ["Are you sure you want to remove \"", file.displayName, "\" from this invoice?"]
            }), /*#__PURE__*/_jsx(Typography, {
              align: "left",
              children: "Once removed, the file will no longer be accessible."
            })]
          }),
          primaryButtonLabel: "Remove file",
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => {
            onRemove(index);
            dismissModal();
          },
          onSecondaryButtonClick: () => dismissModal(),
          onCloseButtonClick: () => dismissModal()
        });
      }
    });
  };
  return /*#__PURE__*/_jsxs(Row, {
    gap: 4,
    children: [/*#__PURE__*/_jsx(FileName, {
      file: file
    }), /*#__PURE__*/_jsx(FileSize, {
      file: file
    }), file.loading ? /*#__PURE__*/_jsx(CircularLoader, {
      testId: AttachmentsTestIds.FileLoader(index)
    }) : isVendor ? /*#__PURE__*/_jsx(CloseButton, {
      testId: AttachmentsTestIds.RemoveButton(index),
      onClick: handleRemove,
      size: "small"
    }) : /*#__PURE__*/_jsx(Box, {
      testId: AttachmentsTestIds.DownloadIcon(index),
      children: /*#__PURE__*/_jsx(Download, {
        width: 24,
        height: 24
      })
    })]
  }, file.displayName);
};
const FileName = _ref3 => {
  let {
    file: {
      url,
      displayName: name
    }
  } = _ref3;
  return /*#__PURE__*/_jsx(Typography, {
    as: "a",
    variant: "paragraph1",
    href: url,
    testId: AttachmentsTestIds.File(name),
    children: name
  });
};
const FileSize = _ref4 => {
  let {
    file: {
      displayName: name,
      fileSize: size
    }
  } = _ref4;
  return /*#__PURE__*/_jsx(Typography, {
    skin: "secondary",
    variant: "paragraph1",
    testId: AttachmentsTestIds.FileSize(name),
    children: "(".concat(formatFileSize(size), ")")
  });
};